import React from "react";
import { FaUserCircle } from "react-icons/fa";
import { MdManageAccounts } from "react-icons/md";
import { PiSignOutBold } from "react-icons/pi";
import { Dropdown, DropdownItem } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import { useSendLogoutMutation } from "../features/auth/authApiSlice";
import { setInitialState } from "../features/reduxworkbook/WorkbookSlice";
import { useDispatch } from "react-redux";
import UseSyncLogout from './SyncLogout';

export default function DropDownComp() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sendLogout] =
    useSendLogoutMutation();
  UseSyncLogout(); // Call the custom hook
  const handleLogout = async () => {

    try {
      const removeLocalStorage = [
        "accessToken",
        "userCompanyDetails",
        "favoritedItems",
        "username",
        "userLogo",
        "firstName",
        "UserCompanyLogo",
        "name",
        "userDetails"
      ];
      await sendLogout();
      // Remove data from sessionStorage and localStorage
      sessionStorage.removeItem("workBookId");




      removeLocalStorage.forEach(key => localStorage.removeItem(key));

      // Set a logout flag in localStorage
      localStorage.setItem("logout", Date.now().toString());
      dispatch(setInitialState());
      // Redirect to login page
      navigate("/login");
    } catch (err) {
      console.error("Failed to logout", err);
    }
  };

  return (
    <>
      <Dropdown
        arrowIcon={false}
        inline
        className="rounded shadow-lg h-20 z-30"
        label={<FaUserCircle className="text-xl" />}
      >
        <Link to="/home/dash/myaccount">
          <DropdownItem className="flex items-center justify-center gap-1 rounded" style={{ color: "black" }}>
            <MdManageAccounts />
            My Account
          </DropdownItem>
        </Link>
        <DropdownItem
          className="flex items-center justify-center gap-1 rounded " style={{ color: "black" }}
          onClick={handleLogout}
        >
          <PiSignOutBold />
          Log-Out
        </DropdownItem>
      </Dropdown>
    </>
  );
}
